Vue.component('app-simple-event-payment-screen', {
    props: {

        event: {
            required: true,
        },

        sessiondata: {
            required: true,
        },

        staffs: {
            required: true,
            default: [],
        },
        pricegroup: {
            required: true,
            default: [],
        },

        pricing: {
            required: true,
        },

        user: {
            required: true,
        },
        scriptendpoint: ""
    },


    /*
     * Initial state of the component's data.
     */
    data: function () {
        return {
            dietary: {
                required: true,
            },
            lastPrice: 0,
            prices: [],
            totalGroupBookingUser: 0,
            redirect_form_key: [],
            used_coupon_discount: 0,
            selectedStaffCount: 0,
            instantlink: '',
            payment_token: '',
            instant_eft_success: false,
            addingNewCard: false,
            newcard: {
                number: '',
                holder: '',
                exp_month: '',
                exp_year: '',
                cvv: '',
                return: '',
                errors: [],
            },
            threeDs: {
                url: '',
                connector: '',
                MD: '',
                TermUrl: '',
                PaReq: '',
            },
            forms: {
                eventSignup: $.extend(
                    true,
                    new AppForm({
                        busy: false,
                        paymentOption: null,
                        card: null,
                        terms: false,
                        donations: 1,
                        errors: [],
                    }),
                    App.forms.eventSignup
                ),
            },
            readyForThreeDs: false,
            checkoutId: null,
            entityId: null
        };
    },

    /*
     * Bootstrap the component. Load the initial data.
    */
  
    ready: function () {

        window.addEventListener('message', (event) => {
            if (typeof event.data == 'string') {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.eventSignup.busy = false;
                        swal.close();
                    }, 2000);
                } catch (e) {
                    this.forms.eventSignup.busy = false;
                    // swal.close()
                }
            }
        });

        this.updatedPrices();

    },


    mounted() {
       this.loadPeachScript();
    },


    computed: {

        /*
         * Compute the total of options the user has selected
         */
        total: function () {

            const price = this.pricing.discounted_price;
           
            if (this.sessiondata.type) {
                var getTotal = this.prices.reduce((item, total) => {
                    return parseFloat(item) + parseFloat(total);
                }, 0);
                var totalDiscount = this.getTotalGroupBookingDiscount();
            } else {
                var getTotal = price;
                var totalDiscount = 0;
            }


            var dietary = this.getTotalDiatry();

            var extras = this.getTotalExtras();

            var donation = this.getDonations();

            var total =
                parseFloat(getTotal) +
                parseFloat(dietary) +
                parseFloat(extras) +
                parseFloat(donation) - parseFloat(totalDiscount);

            if (this.sessiondata.selectedPricingId && total == 0)
                this.forms.eventSignup.paymentOption = null;

            if (total < 0) {
                total = 0;
            }
            return total.toFixed(2);
        },


        discountedAmount: function () {

            var totalDiscount = 0;
            if (this.sessiondata.type) {
                totalDiscount = (parseFloat(this.pricing.price) - parseFloat(this.pricing.discounted_price)) * this.totalGroupBookingUser;
                totalDiscount += parseFloat(this.getTotalGroupBookingDiscount());
            } else{
                totalDiscount = parseFloat(this.pricing.price - this.pricing.discounted_price);
            }
            return totalDiscount.toFixed(2);
        },

        subTotal: function () {

            var sub = parseFloat(this.total) + parseFloat(this.discountedAmount) ;

            return sub.toFixed(2);;
        }

    },

    methods: {

        loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                console.log(this.scriptendpoint);

                document.head.appendChild(script);
            });
        },

        /*
        *
        * Add New Card
        */
        addCard() {
            this.newcard.return = `/events/${this.event.slug}/register?threeDs=yes&venue=${this.sessiondata.selectedVenueId}`;

            this.processPayment();

            this.$http
                .post('/account/billing', this.newcard)
                .then((response) => {
                    if (
                        response.data.redirect === undefined ||
                        response.data.redirect === null
                    ) {
                        this.saveCard(response.data.id);
                        this.addingNewCard = false;
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (
                            var i = response.data.redirect.parameters.length - 1;
                            i >= 0;
                            i--
                        ) {
                            this.redirect_form_key.push({
                                form_key: response.data.redirect.parameters[i].name,
                                form_value: response.data.redirect.parameters[i].value
                            });
                            this.threeDs[response.data.redirect.parameters[i].name] =
                                response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }
                })
                .catch((errors) => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        /**
         * Save User Card
         */
        saveCard(id) {
            this.$http
                .post('/account/billing/card', { id: id })
                .then((response) => {
                    this.user.cards.push(response.data.card);
                    this.forms.eventSignup.card = response.data.card.id;
                    swal.close();
                })
                .catch((errors) => {
                    if (errors.number) {
                        swal({
                            type: 'error',
                            title: 'Whoops',
                            text: errors.number,
                        });
                    }
                });
        },

        getTotalGroupBookingDiscount() {

            var totalDiscount = 0;

            if (!this.sessiondata.selectedPricingId) return 0;

            var price = this.getPriceAfterApplyCoupon(this.pricing.price);

            var lastPrice = price;

            if (this.totalGroupBookingUser > 0 && this.sessiondata.type) {
                if (
                    this.pricegroup.length > 0 &&
                    this.totalGroupBookingUser > 1
                ) {
                    var discount = 0;
                    var len = this.totalGroupBookingUser;
                    for (var i = 2; i <= len; i++) {
                        for (var j = 0; j < this.pricegroup.length; j++) {
                            if (
                                i >= this.pricegroup[j].min_user &&
                                i <= this.pricegroup[j].max_user
                            ) {
                                discount = this.pricegroup[j].discount;
                                var discountPrice = lastPrice * discount / 100;
                                lastPrice = lastPrice - discountPrice;
                            }
                        }
                    }
                }
            }

            totalDiscount = parseFloat(price - lastPrice) * this.totalGroupBookingUser;

            if (this.sessiondata.type && this.staffs.length == 0) {
                totalDiscount = 0;
            }
            return totalDiscount.toFixed(2);
        },

      	popEft() {
            if (!this.validate()) {
                return;
            }
       
            this.process();
            this.forms.eventSignup.busy = true;
            this.getEftLink();
        },

        sendRegistration() {

            
            if (!this.validate()) {
                return;
            }

            if (
                this.forms.eventSignup.paymentOption == 'eft' &&
                this.instant_eft_success == false
            ) {
                this.forms.eventSignup.busy = true;
                return;
            }

            if (
                this.forms.eventSignup.paymentOption == 'cc' &&
                !this.forms.eventSignup.card
            ) {
                swal({
                    type: 'warning',
                    title: 'Error',
                    text:
                        'Unable to register without credit card, please select credit card',
                });
                this.forms.eventSignup.busy = false;
                return;
            }

            var payload = {
                dates: this.sessiondata.dates,
                extras: this.sessiondata.extras,
                dietary: this.sessiondata.dietary,
                terms: this.forms.eventSignup.terms,
                card: this.forms.eventSignup.card,
                donations: this.getDonations(),
                paymentOption: this.forms.eventSignup.paymentOption,
                staffs: this.staffs,
                isgroupbooking: this.sessiondata.isgroupbooking,
                promo_code_id: this.sessiondata.promo_code_id,
                promo_code: this.sessiondata.promo_code,
                selectedEventId: this.sessiondata.selectedEventId,
                selectedVenueId: this.sessiondata.selectedVenueId,
                selectedPricingId: this.sessiondata.selectedPricingId,
                type: this.sessiondata.type  ? 1 : 0,
                id_number: this.sessiondata.id_number,
                id_type: this.sessiondata.id_type,
                country_of_issue: this.sessiondata.country_of_issue,
                incometax_reference_number: this.sessiondata.incometax_reference_number,
                is_new_feature: this.sessiondata.is_new_feature,
            };


            console.log(payload);


            this.processPayment();

            this.$http
                .post('/events/' + this.event.slug + '/register', payload)
                .success(function (response) {
                    this.forms.eventSignup.busy = false;
                    swal.close();
                    window.location = '/dashboard/events';
                })
                .error(function (errors) {
                    this.forms.eventSignup.busy = false;
                    swal({
                        type: 'error',
                        title: 'failed to register user for the event',
                        text: 'try again!',
                        allowOutsideClick: false,
                        showCancelButton: false,
                        showConfirmButton: true,
                    });
                    swal.close();
                    this.forms.eventSignup.errors.set(errors);
                });
        },


        cancelPayment: function () {
            this.forms.eventSignup.busy = false;
        },

         getEftLink: async function() {
           
            this.processPayment();
            this.showModal = true;
        
            await this.loadPeachScript();
            
     
        
            let data = {
                donations: this.getDonations(),
                paymentOption: this.forms.eventSignup.paymentOption,
                staffs: this.staffs,
                isgroupbooking: this.sessiondata.isgroupbooking,
                promo_code_id: this.sessiondata.promo_code_id,
                selectedEventId: this.sessiondata.selectedEventId,
                selectedVenueId: this.sessiondata.selectedVenueId,
                selectedPricingId: this.sessiondata.selectedPricingId,
                type: this.sessiondata.type  ? 1 : 0,
            };
            

            console.log(data);
         
            this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                       let message = "Unable to process your request!";

                        if (error.status == 422) {
                            message = error.data.message;
                        }

                        swal({
                            type: "warning",
                            title: "Error",
                            text: message,
                            showConfirmButton: true
                        });
                    this.forms.eventSignup.busy = false;
                    return;
                });
        },

        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                        const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                    
                    
                                showConfirmButton: true
                            });

                            this.closeModal();
                            this.forms.eventSignup.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.eventSignup.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.eventSignup.busy = false;
                    }
                }
            });

            checkout.render("#payment-form");
        },


        startListener: function () {

            var pusher = new Pusher('5e9e56a5a0ebaf5484b0', {
                cluster: 'mt1',
            });

            var channel = pusher.subscribe('instantefts');

            channel.bind('App\\Events\\InstantEftNotificationReceived', (data) => {
                if (this.payment_token == data.payment_key) {
                    if (data.success === true) {
                        this.process();
                        this.instant_eft_success = true;
                        this.sendRegistration();
                    } else {
                        this.cancelPayment();
                        swal({
                            type: 'error',
                            title: 'Error',
                            text: 'Your Payment has failed, please try again',
                        });
                    }
                }
            });
        },


        process: function () {
            swal({
                title: '',
                text:
                    '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #ffffff;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: 'no-bg',
            });
        },


        processPayment: function () {
            swal({
                type: 'warning',
                title: 'Payment Processing',
                text:
                    'Please wait while we are processing your payment.Do not Refresh page or close browser',
            });
        },


        getAppliedDiscountPrice() {
            if (
                this.usedcoupon != null &&
                this.usedcoupon != '' &&
                this.usedcoupon != undefined
            ) {
                this.promo_code_id = this.usedcoupon.id;
            }
            return this.used_coupon_discount;
        },

        getPriceAfterApplyCoupon: function (price) {

            if (
                this.sessiondata.promo_code_id != null &&
                this.sessiondata.promo_code_id != '' &&
                this.sessiondata.promo_code_id != undefined
            ) {
                if (this.sessiondata.promo_code.discount_type == 'percentage') {
                    var disounted = price * this.sessiondata.promo_code.discount_amount / 100;
                    return parseFloat(price) - parseFloat(disounted);
                } else {
                    return parseFloat(price) - parseFloat(this.sessiondata.promo_code.discount_amount);
                }
            }

            return parseFloat(price);
        },

        /*
          * Calculate the total Pricings
        */

        getTotalPricing: function () {

            if (!this.sessiondata.selectedPricingId) return 0;

            var price = this.pricing.price;

            if (this.pricing.discount > 0)
                price = this.pricing.discounted_price;

            if (this.staffs.length > 0 && this.sessiondata.type) {
                if (
                    this.pricegroup.length > 0 &&
                    this.staffs.length > 1
                ) {
                    var lastPrice = price;
                    var discount = 0;
                    var len = this.staffs.length;
                    for (var i = 2; i <= len; i++) {
                        for (var j = 0; j < this.pricegroup.length; j++) {
                            if (
                                i >= this.pricegroup[j].min_user &&
                                i <= this.pricegroup[j].max_user
                            ) {
                                discount = this.pricegroup[j].discount;
                                var discountPrice = Math.round((lastPrice * discount) / 100);
                                lastPrice = lastPrice - discountPrice;
                            }
                        }
                    }
                    price = lastPrice;
                }
                price = price * this.staffs.length;
            }

            if (this.sessiondata.type && this.staffs.length == 0) {
                price = 0;
            }
            return price;
        },

        /*
         * Calculate the total Diatry Requirements
         */
        getTotalDiatry: function () {
            if (this.sessiondata.dietary != null) {

                if (this.sessiondata.dietary.price > 0) {

                    totalDiatry = this.sessiondata.dietaryt.price;

                    if (this.sessiondata.dates.length > 1) {
                        totalDiatry = totalDiatry * this.sessiondata.dates.length;
                    }
                    if (this.sessiondata.staffs.length > 0) {
                        totalDiatry = totalDiatry * this.staffs;
                    }

                    if (
                        this.sessiondata.type &&
                        this.staffs.length == 0
                    ) {
                        totalDiatry = 0;
                    }
                    return totalDiatry;
                } else {
                    return 0;
                }
            }

            return 0;
        },

        getPriceCalculartion(min, max, title) {
            var price = 0;
            if (this.sessiondata.selectedPricingId != null) {
                price = this.getPriceAfterApplyCoupon(this.pricing.price);
            } else {
                price = this.getPriceAfterApplyCoupon(this.pricing.price);
            }
            var discount = 0;
            var discountPrice = 0;
            var lowerprice = price;
            var i, j;
            if (max == 0) {
                max = min;
            }

            for (i = 2; i <= min; i++) {
                for (j = 0; j < this.pricegroup.length; j++) {
                    if (
                        i >= this.pricegroup[j].min_user &&
                        i <= this.pricegroup[j].max_user
                    ) {
                        discount = this.pricegroup[j].discount;
                        discountPrice = Math.round((lowerprice * discount) / 100);
                        lowerprice = lowerprice - discountPrice;
                    }
                }
            }

            for (i = 2; i <= max; i++) {
                for (j = 0; j < this.pricegroup.length; j++) {
                    if (
                        i >= this.pricegroup[j].min_user &&
                        i <= this.pricegroup[j].max_user
                    ) {
                        discount = this.pricegroup[j].discount;
                        discountPrice = Math.round((price * discount) / 100);
                        price = price - discountPrice;
                    }
                }
            }

            if (max == min) {
                return 'From ' + price + ' per person';
            }
            return 'From ' + lowerprice + ' - ' + price + ' per person';
        },

        /*
         * Calculate the total Extras
         */
        getTotalExtras: function () {

            var total = 0;

            if (this.sessiondata.extras.length > 0) {
                this.sessiondata.extras.forEach((extra) => {
                    total = parseInt(total) + parseInt(extra.price);
                });
            }
            if (this.staffs.length > 0) {
                total = total * this.staffs.length;
            }

            if (this.sessiondata.type && this.staffs.length == 0) {
                total = 0;
            }

            return total;
        },

        updatedPrices: function () {
            this.prices = [];
            this.totalGroupBookingUser = 0;
            this.$http
                .post('/get_price_details', {
                    staffs: this.staffs,
                    price_id: this.sessiondata.selectedPricingId,
                })
                .success((response) => {
                    for (var i = 0; i < response.length; i++) {
                        this.prices.push(response[i]);
                        if (this.getPriceAfterApplyCoupon(this.pricing.price) == response[i]) {
                            this.totalGroupBookingUser += 1;
                        }
                    }
                })
                .catch((errors) => {
                    // this.errors.invite=errors.data;
                });

        },


        getDonations: function () {
           
            var total = 0;
            if (this.sessiondata.donations) {
                total = this.sessiondata.donations;
            }
            return total;
        },


        register: function () {
            this.forms.eventSignup.errors.forget();
            this.forms.eventSignup.busy = true;
            this.sendRegistration();
        },

        validate: function() {
          
            if (!this.forms.eventSignup.terms) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Please accept term's and condition to process booking!"
                });
                this.forms.eventSignup.busy = false;
                return false;
            }

            return true;
        }

    },
});


// WEBPACK FOOTER //
// ./resources/assets/js/events/single/payment.js